import React from 'react';
import { motion } from 'framer-motion';
import { Settings, Shield, Users, LineChart, Sliders, FileText } from 'lucide-react';
export function WhyStopply() {
  const features = [{
    icon: Settings,
    title: 'Custom KPIs',
    desc: 'We track what actually matters to your specific business model.'
  }, {
    icon: Shield,
    title: 'White-Labeled',
    desc: 'Your branding, your domain, your professional presentation.'
  }, {
    icon: Users,
    title: 'Marketing Strategists',
    desc: 'Built and managed by experts who understand growth.'
  }, {
    icon: LineChart,
    title: 'Business Intelligence',
    desc: 'Deep insights that go beyond surface-level vanity metrics.'
  }, {
    icon: Sliders,
    title: 'Unlimited Customization',
    desc: 'If you can measure it, we can build a dashboard for it.'
  }, {
    icon: FileText,
    title: 'Executive Reporting',
    desc: 'Clean, automated reports ready for board meetings.'
  }];
  return <section id="why-stopply" className="py-32" data-id="element-297">
      <div className="max-w-7xl mx-auto px-6" data-id="element-298">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20" data-id="element-299">
          <div data-id="element-300">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-4xl md:text-5xl font-bold mb-6" data-id="element-301">
              Built around your business.
              <br data-id="element-302" />
              <span className="text-textSecondary" data-id="element-303">Not ours.</span>
            </motion.h2>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-lg text-textSecondary space-y-4" data-id="element-304">
              <p data-id="element-305">No templates. No generic dashboards.</p>
              <p className="text-white font-medium" data-id="element-306">
                Built around the metrics that matter to you. It evolves as you
                do.
              </p>
            </motion.div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-307">
            {features.map((feature, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-card border border-white/5 rounded-2xl p-6 hover:bg-white/[0.02] transition-colors" data-id="element-308">
                <feature.icon className="text-accent mb-4" size={24} data-id="element-309" />
                <h3 className="text-white font-medium mb-2" data-id="element-310">{feature.title}</h3>
                <p className="text-sm text-textSecondary" data-id="element-311">{feature.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}